var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 d-flex flex-column mb-3" }, [
    _c("div", { staticStyle: { flex: "1", "margin-left": "45px" } }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("section-title", {
              attrs: { title: _vm.$t("apps.inventory.label.lotnumber") }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        {
          ref: "lot-wrapper",
          staticClass: "lot-wrapper mb-2",
          class: [
            { "col-md-9": !_vm.disabled, "col-md-8": _vm.disabled },
            _vm.lotClassName
          ]
        },
        [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticStyle: { width: "45px" } }),
            _vm._v(" "),
            _c("div", { staticClass: "form-row", staticStyle: { flex: "1" } }, [
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(_vm._s(_vm.$t("apps.inventory.message.bin")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("BaseDropdown", {
                      attrs: {
                        options: _vm.binOptions,
                        disabled: _vm.disabled
                      },
                      model: {
                        value: _vm.value.binId,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "binId", $$v)
                        },
                        expression: "value.binId"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("apps.inventory.message.dateproduct"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("BaseInputDatePicker", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.value.dateProduct,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "dateProduct", $$v)
                        },
                        expression: "value.dateProduct"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("apps.inventory.message.dateexpire"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("BaseInputDatePicker", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.value.dateExpire,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "dateExpire", $$v)
                        },
                        expression: "value.dateExpire"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(_vm._s(_vm.$t("apps.inventory.message.cost")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("BaseInputNumber", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.value.cost,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "cost", $$v)
                        },
                        expression: "value.cost"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccd57e64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccd57e64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseGRPutAwayLot.vue
// module id = null
// module chunks = 